import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import InfoForm from './InfoForm';
import Card from '../shared/Card';
import API from '../../utils/api';
import GTMService from '../../utils/gtm';
import { formatPrice, getIsAdult } from '../../utils/helpers';
import { addProductToCart, removeProductFromCart } from '../../reducers/cart';
import {
  selectTransportOption,
  deselectTransportOption,
  setTransportChoice,
} from '../../reducers/form';

const api = new API();
const gtm = new GTMService();

const TYPE_ARRIVAL = 'Arrival';
const TYPE_DEPARTURE = 'Departure';

const ROUNDTRIP = 'roundtrip';
const PICKUP = 'pickup';
const DROPOFF = 'dropoff';
const NONE = 'none';

const OPTIONS = [
  {
    id: ROUNDTRIP,
    label: 'Roundtrip pick up and drop off',
  },
  {
    id: PICKUP,
    label: 'Pick up only',
  },
  {
    id: DROPOFF,
    label: 'Drop off only',
  },
  {
    id: NONE,
    label: 'I do not need travel arrangements',
  },
];

const AirportSuttle = ({
  isAdult,
  transportChoice,
  setTransportChoice,
  selectedTransportOptions,
  addProductToCart,
  removeProductFromCart,
  selectTransportOption,
  deselectTransportOption,
}) => {
  const [choice, setChoice] = useState(transportChoice);
  const [transportOptions, setTransportOptions] = useState([]);
  const [startingPrice, setStartingPrice] = useState(0);
  const [transportUnaccompanniedOption, setTransportUnaccompagnniedOption] =
    useState(null);
  const [transportUnaccompanniedInternationalOption, setTransportUnaccompagnniedInternationalOption] =
      useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    let skip = false;

    Promise.all([
      api.fetchTransport(),
      api.fetchTransportUnaccompannied(),
      api.fetchTransportUnaccompanniedInternational(),
    ]).then((res) => {
      if (skip) {
        return;
      }

      setTransportOptions(res[0].results);
      setStartingPrice(res[0].starting_price);
      setTransportUnaccompagnniedOption(res[1]);
      console.log('Unaccompagnnied', res[1]);
      window.unaccompagnnied = res[1];
      setTransportUnaccompagnniedInternationalOption(res[2]);
      console.log('Unaccompagnnied International', res[2]);
      window.unaccompagnnied_international = res[2];
    });

    return () => (skip = true);
  }, []);

  useEffect(() => {
    setTransportChoice(choice);
  }, [choice, setTransportChoice]);

  const handleChange = (type, data) => {
    handleRemove();
    setChoice({
      ...choice,
      [type]: {
        ...choice[type],
        ...data,
      },
    });
  };

  const handleConfirm = async () => {
    const payload = {
      type: 'transport',
      quantity: 1,
      refundable: false,
    };

    const products = [];

    if (
      (choice[PICKUP] && choice[PICKUP].unacompannied) ||
      (choice[DROPOFF] && choice[DROPOFF].unacompannied)
    ) {
      let quantity = choice[PICKUP] && choice[PICKUP].unacompannied ? 1 : 0;
      quantity += choice[DROPOFF] && choice[DROPOFF].unacompannied ? 1 : 0;

      console.log('choice:', choice);
      console.log('transportUnaccompanniedInternationalOption:', transportUnaccompanniedInternationalOption);

      if (
        (choice[PICKUP] && choice[PICKUP].unacompanniedinternational && choice[PICKUP].unacompannied) ||
        (choice[DROPOFF] && choice[DROPOFF].unacompanniedinternational && choice[DROPOFF].unacompannied)
      ) {
        products.push({
          ...payload,
          quantity,
          attributes: {
            type: 'unacompannied',
          },
          product: transportUnaccompanniedInternationalOption,
          product_id: transportUnaccompanniedInternationalOption.id,
          unique_id: transportUnaccompanniedInternationalOption.id,
          name: 'Unaccompanied Minor International',
        });
        console.log('Add Unaccompanied Minor International');
      } else if (
        (choice[PICKUP] && choice[PICKUP].unacompannied) ||
        (choice[DROPOFF] && choice[DROPOFF].unacompannied)
      ) {
        products.push({
          ...payload,
          quantity,
          attributes: {
            type: 'unacompannied',
          },
          product: transportUnaccompanniedOption,
          product_id: transportUnaccompanniedOption.id,
          unique_id: transportUnaccompanniedOption.id,
          name: 'Unaccompanied Minor',
        });
        console.log('Add Unaccompanied Minor');
      }

      console.log('quantity:', quantity);
      console.log('products:', products);

    }



    if (choice[PICKUP]) {
      const product = transportOptions.find(
        (o) => o.id === choice[PICKUP].airport
      );
      products.push({
        ...payload,
        attributes: {
          type: 'arrival_transport',
        },
        product,
        product_id: choice[PICKUP].airport,
        unique_id: 'arrival', // Unique id here because airport ids can be same for departure and arrival
        name: `Pickup at ${product.airport}`,
      });
    }

    if (choice[DROPOFF]) {
      const product = transportOptions.find(
        (o) => o.id === choice[DROPOFF].airport
      );
      products.push({
        ...payload,
        attributes: {
          type: 'departing_transport',
        },
        type: 'transport',
        product,
        product_id: choice[DROPOFF].airport,
        unique_id: 'departing',
        name: `Dropoff at ${product.airport}`,
      });
    }

    setIsProcessing(true);
    await Promise.all(
      products.map(async (p) => {
        const res = await addProductToCart(p);
        if (!res) {
          console.error('An error happened while adding a transport option');
          return null;
        }

        gtm.trackAddToCart(p, 'transport');
        selectTransportOption(p.unique_id, {
          //participantProductId: res.participant_product_id,
          participantProductId: p.unique_id,
          name: p.name,
          product: p,
        });
        return res;
      })
    );
    setIsProcessing(false);
  };

  const handleRemove = async () => {
    setIsProcessing(true);
    const keys = Object.keys(selectedTransportOptions);
    await Promise.all(
      keys.map(async (key) => {
        //const id = selectedTransportOptions[key].participantProductId;
        const id = selectedTransportOptions[key].product.product_id;
        const res = await removeProductFromCart(id);
        deselectTransportOption(key);
        return res;
      })
    );
    setIsProcessing(false);
  };

  const renderSummary = (key, label) => {
    const data = choice[key];
    if (!data) {
      return null;
    }

    const product = transportOptions.find((o) => o.id === data.airport);
    if (!product) {
      return null;
    }

    return (
      <div className="field__airport">
        <h5 className="field__label">{label}</h5>
        <div className="field__details">
          {label} airport: {product.airport} - {formatPrice(product.price)}
        </div>
        {!isAdult && (
          <div className="field__minor">
            Unaccompanied minor: {data.unacompannied ? 'Yes' : 'No'}
          </div>
        )}
      </div>
    );
  };

  const hasValidData = (key) => {
    if (!choice) {
      return false;
    }

    if (!choice.hasOwnProperty(key)) {
      return true;
    }

    if (!choice[key]) {
      return false;
    }

    if (
      !choice[key].airport ||
      (!isAdult && choice[key].unacompannied === undefined)
    ) {
      return false;
    }

    return true;
  };

  const isPickup = choice && choice.hasOwnProperty(PICKUP);
  const isDropoff = choice && choice.hasOwnProperty(DROPOFF);
  const hasAddedAnOption = Object.keys(selectedTransportOptions).length > 0;
  const getDefaultChoice = () => {
    if (!choice) {
      return NONE;
    }

    if (isPickup && isDropoff) {
      return ROUNDTRIP;
    }

    if (isPickup) {
      return PICKUP;
    }

    if (isDropoff) {
      return DROPOFF;
    }
  };

  return (
    <Card title="Airport Shuttle" startingPrice={startingPrice}>
      <label
        className={classNames('field__select', {
          'field__input--selected': !!choice,
        })}
      >
        <select
          type="text"
          name="choice"
          defaultValue={getDefaultChoice()}
          onChange={(e) => {
            // Remove choice and all selected options from cart
            handleRemove();
            setChoice(null);

            const value = e.target.value;
            const set = () => {
              switch (value) {
                case ROUNDTRIP:
                  setChoice({
                    [PICKUP]: null,
                    [DROPOFF]: null,
                  });
                  break;
                case PICKUP:
                  setChoice({
                    [PICKUP]: null,
                  });
                  break;
                case DROPOFF:
                  setChoice({
                    [DROPOFF]: null,
                  });
                  break;
                case NONE:
                  setChoice(null);
                  break;
                default:
                  break;
              }
            };

            // Defer setting choice to invalidate info form selection
            // XXX Not ideal, we can for eg set a key on InforForm
            setTimeout(() => {
              set();
            }, 500);
          }}
        >
          {OPTIONS.map((o) => (
            <option
              key={o.id}
              value={o.id}
              className={classNames('field__option', {
                'field__option--selected':
                  choice && choice.hasOwnProperty(o.id),
              })}
            >
              {o.label}
            </option>
          ))}
        </select>
      </label>

      <div className="field select field__choices">
        {isPickup && (
          <InfoForm
            isAdult={isAdult}
            type={TYPE_ARRIVAL}
            transportOptions={transportOptions}
            data={choice[PICKUP]}
            onChange={(data) => handleChange(PICKUP, data)}
          />
        )}

        {isDropoff && (
          <InfoForm
            isAdult={isAdult}
            type={TYPE_DEPARTURE}
            transportOptions={transportOptions}
            data={choice[DROPOFF]}
            onChange={(data) => handleChange(DROPOFF, data)}
          />
        )}
      </div>

      <div className="field__summary">
        {hasValidData(PICKUP) && hasValidData(DROPOFF) && (
          <Fragment>
            <h4 className="field__title">Summary of travel arrangements</h4>
            {renderSummary(PICKUP, 'Arrival')}
            {renderSummary(DROPOFF, 'Departure')}
          </Fragment>
        )}

        {hasValidData(PICKUP) && hasValidData(DROPOFF) && (
          <Fragment>
            {!hasAddedAnOption ? (
              <button
                type="button"
                onClick={handleConfirm}
                disabled={isProcessing}
              >
                Confirm
              </button>
            ) : (
              <button
                type="button"
                className="field__button--selected"
                onClick={handleRemove}
                disabled={isProcessing}
              >
                Remove
              </button>
            )}
          </Fragment>
        )}
      </div>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  isAdult: getIsAdult(state.form.camper.age),
  transportChoice: state.form.transportChoice,
  selectedTransportOptions: state.form.selectedTransportOptions,
});

const mapDispatchToProps = (dispatch) => ({
  addProductToCart: (product) => dispatch(addProductToCart(product)),
  removeProductFromCart: (id) => dispatch(removeProductFromCart(id)),
  selectTransportOption: (key, value) =>
    dispatch(selectTransportOption(key, value)),
  deselectTransportOption: (key) => dispatch(deselectTransportOption(key)),
  setTransportChoice: (choice) => dispatch(setTransportChoice(choice)),
});

AirportSuttle.propTypes = {
  isAdult: PropTypes.bool.isRequired,
  transportChoice: PropTypes.object,
  selectedTransportOptions: PropTypes.object.isRequired,
  addProductToCart: PropTypes.func.isRequired,
  removeProductFromCart: PropTypes.func.isRequired,
  selectTransportOption: PropTypes.func.isRequired,
  deselectTransportOption: PropTypes.func.isRequired,
  setTransportChoice: PropTypes.func.isRequired,
};

AirportSuttle.displayName = 'AirportSuttle';

export default connect(mapStateToProps, mapDispatchToProps)(AirportSuttle);
